import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { useHotkeys } from 'react-hotkeys-hook';
import ContextButton from '../ContextButton';
import { getActiveSelectedMenu } from 'ducks/layout';
import styled from 'styled-components';
import PencilIcon from '@ingka/ssr-icon/paths/pencil';

const DisabledText = styled.div`
  display: none;
  :not(:focus):not(:active) {
    clip: rect(0 0 0 0);
    clip-path: inset(100%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;

const StyledContextButton = styled(ContextButton)`
  clip: rect(0 0 0 0);
  clip-path: inset(100%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  &:focus-visible {
    overflow: initial;
    position: relative;
    clip: auto;
    height: auto;
    width: auto;
    clip-path: initial;
  }
`;

type Props = {
  size?: 'xsmall' | 'small' | 'medium';
};

const Customise = ({ size }: Props) => {
  const { formatMessage } = useIntl();
  const selectedGroupId = useSelector(getActiveSelectedMenu)[0];

  // This is needed for the componnent to render with the correct groupId
  useEffect(() => {}, [selectedGroupId]);

  const onCustomiseClicked = () => {
    const elementToFocus = document.getElementById('selectedmenu-thumbswrapper');

    if (elementToFocus !== null) {
      const buttons = elementToFocus.querySelectorAll('button:not([disabled])');
      if (buttons[0] !== undefined) {
        (buttons[0] as HTMLElement).focus();
      }
    }
  };

  useHotkeys('backspace', onCustomiseClicked, [selectedGroupId]);
  useHotkeys('del', onCustomiseClicked, [selectedGroupId]);

  return (
    <StyledContextButton
      label={formatMessage({ id: 'storageone.contextMenuCustomise' })}
      dataTestId="customise"
      onClick={onCustomiseClicked}
      ssrIcon={PencilIcon}
      ariaHidden
      size={size}
    >
      <DisabledText>{formatMessage({ id: 'storageone.contextMenuCustomise' })}</DisabledText>
    </StyledContextButton>
  );
};

export default Customise;
